import React, { ComponentPropsWithoutRef } from "react";
import styled from "styled-components";

type Props = {
  onClick: () => void;
  text: string;
  isActive: boolean;
  top: number;
  children: React.ReactNode;
};

interface MapOverlayProps extends ComponentPropsWithoutRef<"div"> {
  top: number;
  isActive: boolean;
}

export default function MapButton({
  text,
  isActive,
  onClick,
  top,
  children,
}: Props) {
  return (
    <MapOverlayButton onClick={onClick} top={top} isActive={isActive}>
      {children}
      <MapOverlayButtonText top={top} isActive={isActive}>
        {text}
      </MapOverlayButtonText>
    </MapOverlayButton>
  );
}

const MapOverlayButton = styled.div<MapOverlayProps>`
  display: flex;
  width: 78px;
  height: 70px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 6px;
  position: absolute;
  right: 20px;
  cursor: pointer;
  ${({ top, isActive }) => ({
    top: `${top}px`,
    border: isActive
      ? "1px solid var(--Primary-blue600, #2E66F6)"
      : "1px solid var(--GrayScale-gray400, #d8ddea)",
    background: isActive
      ? "var(--Primary-blue200, #F3F6FF)"
      : "var(--GrayScale-white, #fff)",
    ":hover": {
      border: "1px solid var(--GrayScale-gray400, #D8DDEA)",
      background: "var(--GrayScale-gray100, #F8F9FB)",
    },
  })}
`;

const MapOverlayButtonText = styled.div<MapOverlayProps>`
  text-align: center;
  /* subheadline2 */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.28px;
  cursor: pointer;
  ${({ isActive }) => ({
    color: isActive
      ? "var(--Primary-blue600, #2e66f6)"
      : "var(--GrayScale-gray900, #25282F)",
    ":hover": {
      color: "var(--GrayScale-gray800, #565B69)",
    },
  })}
`;
